/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.ProductDevelopment {

    import fld = PDQuotationAdditionalChargesRow.Fields;

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.registerEditor()
    export class PDQuotationAdditionalChargesEditor extends _Ext.GridEditorBase<PDQuotationAdditionalChargesRow> {
        protected getColumnsKey() { return "ProductDevelopment.PDQuotationAdditionalCharges"; }
        protected getLocalTextPrefix() { return PDQuotationAdditionalChargesRow.localTextPrefix; }
        protected get_ExtGridOptions(): ExtGridOptions { return Q.deepClone(q.DefaultEditorGridOptions); }

        public pendingChanges: Q.Dictionary<any> = {};



        constructor(container: JQuery) {
            super(container);
        }
        protected getColumns() {

            let columns = super.getColumns();

            let num = ctx => ColumnFormatter.numericInputFormatter(ctx, this);
            Q.first(columns, x => x.field === fld.Rate).format = num;

            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });
            this.view.refresh();
            return columns;
        }

        public getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }
        protected getButtons() {
            var buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != "add-button");
            buttons.push({
                title: "Select Charges",
                cssClass: "add-button",
                hotkey: "alt+k",
                onClick: () => {
                    var grid = Common.AdditionalChargesSelectGrid;
                    var filters: _Ext.SelectGridFilters = {
                        VoucherTypeId: 104,
                        ApplicableOn: 1
                    }
                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: true, title: "Select Items",
                        preSelectedKeys: this.value.map(k => k.AdditionalChargeId), GridFilters: filters
                    });

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.AdditionalChargeId == t.AdditionalChargeId) });
                        let charges = [];
                        selectedItems2.forEach(function (value: OMS.AdditionalChargesVouchersRow) {
                            var additionalcharge: PDQuotationAdditionalChargesRow = {
                                AdditionalChargeId: value.AdditionalChargeId,
                                Rate: value.Rate,
                                AdditionalChargeCode: value.AdditionalChargeCode,
                                AdditionalChargeName: value.AdditionalChargeName,
                                ApplicableOn: value.ApplicableOn,
                                RateType: value.RateType
                            };

                            charges.push(additionalcharge)
                        });
                        for (let charge of charges) {
                            charge[this.getIdProperty()] = "`" + this.nextId++;
                            this.view.addItem(charge);
                        }
                    }
                    pickerDialog.dialogOpen();

                }
            });

            return buttons;
        }


        setData(charges: any[]) {
            for (let charge of charges) {
                charge[this.getIdProperty()] = "`" + this.nextId++;
                this.view.addItem(charge);
            }
        }
    }
}